import { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";

export default function RequestDashboard() {
  const [requests, setRequests] = useState([]);
  const [filterStatus, setFilterStatus] = useState("");
  const [filterType, setFilterType] = useState("");
  const [sortKey, setSortKey] = useState("requested_at");
  const [sortOrder, setSortOrder] = useState("desc");
  const [filterDevice, setFilterDevice] = useState("");

  useEffect(() => {
    fetchRequests();
    const interval = setInterval(fetchRequests, 5000); // Auto-refresh every 5 seconds
    return () => clearInterval(interval);
  }, []);

  const fetchRequests = () => {
    axios.get("/api/requests")
      .then(response => setRequests(response.data))
      .catch(error => console.error("Error fetching requests:", error));
  };

  const requestStatusOptions = [
    { value: "", label: "All" },
    { value: "pending", label: "Pending" },
    { value: "in_progress", label: "In Progress" },
    { value: "completed", label: "Completed" },
    { value: "failed", label: "Failed" }
  ];

  const requestTypeOptions = [
    { value: "", label: "All" },
    { value: "all_raw", label: "All Raw Images" },
    { value: "range_raw", label: "Range of Raw Images" },
    { value: "processed", label: "Processed Data" },
    { value: "network_objects", label: "Network Objects" }
  ];

  const deviceNameOptions = [
    { value: "", label: "All Devices" },
      ...Array.from(new Set(requests.map(req => req.device_name)))
      .map(name => ({ value: name, label: name }))
  ];

  const filteredRequests = requests.filter(req =>
    (!filterStatus || req.status === filterStatus) &&
    (!filterType || req.request_type === filterType) &&
    (!filterDevice || req.device_name === filterDevice)
  );

  const sortedRequests = [...filteredRequests].sort((a, b) => {
  let valA = a[sortKey];
  let valB = b[sortKey];

  // Handle dates
  if (sortKey === "requested_at") {
    valA = new Date(valA);
    valB = new Date(valB);
  }
  if (sortKey === "dataset_name") {
    const extractDate = (name) => {
      const match = name.match(/\d{4}-\d{2}-\d{2}/); // e.g., 2025-08-01
      return match ? new Date(match[0]) : new Date(0); // fallback to epoch if no date
    };
    valA = extractDate(valA);
    valB = extractDate(valB);
  }
  if (valA < valB) return sortOrder === "asc" ? -1 : 1;
  if (valA > valB) return sortOrder === "asc" ? 1 : -1;
  return 0;
  });

  const handleSort = (key) => {
    if (sortKey === key) {
      setSortOrder(prev => prev === "asc" ? "desc" : "asc");
    } else {
      setSortKey(key);
      setSortOrder("asc");
    }
  };
  return (
    <div className="p-6 max-w-4xl mx-auto bg-white rounded-lg shadow-md">
      <h2 className="text-xl font-semibold mb-4">Request Dashboard</h2>

      <div className="flex gap-4 mb-4">
        <div className="w-1/2">
          <label className="block text-gray-700">Filter by Status</label>
          <Select options={requestStatusOptions} onChange={(option) => setFilterStatus(option.value)} />
        </div>
        <div className="w-1/2">
          <label className="block text-gray-700">Filter by Type</label>
          <Select options={requestTypeOptions} onChange={(option) => setFilterType(option.value)} />
        </div>
        <div className="w-1/2">
          <label className="block text-gray-700">Filter by Device</label>
          <Select options={deviceNameOptions} onChange={(option) => setFilterDevice(option.value)} />
        </div>
      </div>

      <table className="w-full border-collapse border border-gray-200">
        <thead>
          <tr className="bg-gray-100">
            <th className="border px-4 py-2 cursor-pointer" onClick={() => handleSort("device_name")}> Device Name {sortKey === "device_name" && (sortOrder === "asc" ? "▲" : "▼")}</th>
            <th className="border px-4 py-2 cursor-pointer" onClick={() => handleSort("dataset_name")}>Dataset Name {sortKey === "dataset_name" && (sortOrder === "asc" ? "▲" : "▼")}</th>
            <th className="border px-4 py-2">Request Type</th>
            <th className="border px-4 py-2">Status</th>
            <th className="border px-4 py-2 cursor-pointer" onClick={() => handleSort("requested_at")}>Requested At {sortKey === "requested_at" && (sortOrder === "asc" ? "▲" : "▼")}</th>
            <th className="border px-4 py-2">Parameters</th>
          </tr>
        </thead>
        <tbody>
          {sortedRequests.length > 0 ? (
            sortedRequests.map(req => (
              <tr key={req.id} className="border-b">
                <td className="border px-4 py-2">{req.device_name}</td>
                <td className="border px-4 py-2">{req.dataset_name}</td>
                <td className="border px-4 py-2">{req.request_type.replace("_", " ")}</td>
                <td className={`border px-4 py-2 font-semibold ${req.status === "completed" ? "text-green-600" : req.status === "pending" ? "text-yellow-600" : "text-red-600"}`}>
                  {req.status}
                </td>
                <td className="border px-4 py-2">{new Date(req.requested_at).toLocaleString()}</td>
                <td className="border px-4 py-2">
                {req.request_type === "range_raw" && req.start_frame != null && req.end_frame != null
                ? `${req.start_frame} - ${req.end_frame}`
                : req.request_type === "network_objects" && req.network_score != null
                ? `Network Score: ${req.network_score}`
                : ""}
               </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center py-4">No requests found</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
